import { render } from "./AIChatDetails.vue?vue&type=template&id=6903d563"
import script from "./AIChatDetails.vue?vue&type=script&lang=js"
export * from "./AIChatDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__